import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { logDataError } from "../lib/errors";
import { subscribeToOrders } from "../lib/orders";

export function useOrders() {
  const { currentUser } = useAuth();
  const [state, setState] = useState({ orders: [], loading: true, error: null });

  useEffect(() => {
    if (!currentUser) return undefined;
    return subscribeToOrders(
      currentUser.uid,
      (orders) => setState({ orders, loading: false, error: null }),
      (error) => {
        logDataError("leer las órdenes del usuario", error);
        setState({ orders: [], loading: false, error });
      }
    );
  }, [currentUser]);

  return state;
}
